import React from 'react';
import PageBanner from '@/components/Banner/PageBanner';
import t from '@/utils/Language/UI-translations';

const PendingSubmissionBanner = ({ resource }) => {
  if (!resource?.has_pending_submission) {
    return null;
  }

  return (
    <PageBanner type="info" icon={['far', 'pen-to-square']} iconColor="blue">
      <strong>{t('This resource is being updated by our team!')}</strong> {t('Please look for changes in about 1-3 days_')}
    </PageBanner>
  );
};

export default PendingSubmissionBanner;
